import React from 'react';

export const QuestionnaireAdminSectionModal = ({
  isOpen,
  sectionForm,
  setSectionForm,
  onClose,
  onSubmit,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="questionnaire-admin-section-modal-overlay">
      <div className="bg-white rounded-2xl w-full max-w-lg p-6" data-testid="questionnaire-admin-section-modal">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-testid="questionnaire-admin-section-modal-title">Nova Seção</h3>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="questionnaire-admin-section-form">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Título (Japonês)</label>
            <input
              type="text"
              value={sectionForm.title_jp}
              onChange={(event) => setSectionForm({ ...sectionForm, title_jp: event.target.value })}
              className="w-full px-4 py-2 border rounded-lg"
              placeholder="日本語タイトル"
              data-testid="questionnaire-admin-add-section-title-jp-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Título (Português) *</label>
            <input
              type="text"
              value={sectionForm.title_br}
              onChange={(event) => setSectionForm({ ...sectionForm, title_br: event.target.value })}
              required
              className="w-full px-4 py-2 border rounded-lg"
              placeholder="Título em português"
              data-testid="questionnaire-admin-add-section-title-br-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Título (Inglês)</label>
              <input
                type="text"
                value={sectionForm.title_us}
                onChange={(event) => setSectionForm({ ...sectionForm, title_us: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg"
                placeholder="English title"
                data-testid="questionnaire-admin-add-section-title-us-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Título (Espanhol)</label>
              <input
                type="text"
                value={sectionForm.title_es}
                onChange={(event) => setSectionForm({ ...sectionForm, title_es: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg"
                placeholder="Título en español"
                data-testid="questionnaire-admin-add-section-title-es-input"
              />
            </div>
          </div>
          <div className="flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 py-2 border rounded-lg" data-testid="questionnaire-admin-add-section-cancel-button">
              Cancelar
            </button>
            <button type="submit" className="flex-1 py-2 bg-green-600 text-white rounded-lg" data-testid="questionnaire-admin-add-section-submit-button">
              Adicionar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
